import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './inactive-user-dialog.component.html',
  styleUrls: ['./inactive-user-dialog.component.scss'],
  standalone: false,
})
export class InactiveUserDialogComponent {
  constructor(private dialog: MatDialogRef<InactiveUserDialogComponent>) {}

  public close(): void {
    this.dialog.close();
  }
}
